"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.propTypes = exports.defaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gridFramework = require("@bootstrap-styled/css-mixins/lib/grid-framework");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Definition Description
 *
 */
var defaultProps = {
  theme: {
    '$grid-columns': '12',
    '$grid-gutter-width': '30px',
    '$grid-breakpoints': {
      xs: '0',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px'
    },
    '$enable-grid-classes': true
  }
};
exports.defaultProps = defaultProps;
var propTypes = {
  /** Theme variables. Can be: */
  theme: _propTypes.default.shape({
    '$grid-columns': _propTypes.default.string,
    '$grid-gutter-width': _propTypes.default.string,
    '$grid-breakpoints': _propTypes.default.object,
    '$enable-grid-classes': _propTypes.default.bool
  })
};
/**
 * Use our `<Dd />` component to describe a term/name in a description list.
 */

exports.propTypes = propTypes;

var Dd = _styledComponents.default.dd.withConfig({
  displayName: "Dd",
  componentId: "sc-1b1ksu8-0"
})(["  margin-bottom:.5rem;margin-left:0;", ""], function (props) {
  return "\n    ".concat((0, _gridFramework.makeGridColumns)(props.theme['$enable-grid-classes'], props.theme['$grid-columns'], props.theme['$grid-gutter-width'], props.theme['$grid-breakpoints']), "\n  ");
});

Dd.defaultProps = defaultProps;
Dd.propTypes = propTypes;
/** @component */

var _default = Dd;
exports.default = _default;